module.exports = __webpack_public_path__ + "img/DrDanielAllida_Photo1.ed919114.jpg";